import { useEnvironment } from '@wix/yoshi-flow-editor';
import loadable from '@wix/yoshi-flow-editor/loadable';
import type { FC } from 'react';
import React from 'react';

import { classes, st } from './About.st.css';
import { EmptyEditor } from './EmptyEditor';

const Viewer = loadable(
  () => import(/* webpackChunkName: "Viewer" */ './Viewer'),
);

const AboutEditComponent = loadable(
  () =>
    import(/* webpackChunkName: "AboutEditComponent" */ './AboutEditComponent'),
);

export type AboutProps = {
  isEditMode?: boolean;
  isEmptyState?: boolean;
  setEditMode: (value: boolean) => void;
  showButtonsInEditor: boolean;
  showPlaceholderDescription: boolean;
};

export const About: FC<AboutProps> = ({
  isEditMode,
  isEmptyState,
  showButtonsInEditor,
  showPlaceholderDescription,
  setEditMode,
}) => {
  const { isEditor } = useEnvironment();

  const aboutEditWithProps = (
    <AboutEditComponent
      setEditMode={setEditMode}
      isEditMode={isEditMode}
      showButtonsInEditor={showButtonsInEditor}
      isEmptyState={isEmptyState}
    />
  );

  // The transition prevents flickering of toolbar icons in dekstop on editor activation
  // Without transition browser spends some time to paint the icons which causes a flickering effect
  const emptyStateWithTransition = (
    <div className={classes.transitionContainer}>
      <div className={st(classes.transitionWrapper, { hidden: isEditMode })}>
        {/* EmptyEditor is required because RicosEditor is not working in the SSR */}
        <EmptyEditor setEditMode={setEditMode} />
      </div>
      <div className={st(classes.transitionWrapper, { hidden: !isEditMode })}>
        {aboutEditWithProps}
      </div>
    </div>
  );

  return (
    <div className={st(classes.root)}>
      {showPlaceholderDescription ? (
        <Viewer showPlaceholderDescription={showPlaceholderDescription} />
      ) : isEditor ? (
        aboutEditWithProps
      ) : isEditMode || isEmptyState ? (
        emptyStateWithTransition
      ) : (
        <Viewer />
      )}
    </div>
  );
};
